import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var TableauSvg = function TableauSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8762C",
    d: "M15 10.973h-2.508V8h-.984v2.973H9v1.054h2.508V15h.984v-2.973H15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C62036",
    d: "M10 16.602H7.475V14H6.52v2.602H4v.796h2.52V20h.955v-2.602H10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A869A",
    d: "M20 6.615h-2.52V4h-.96v2.615H14v.792h2.52V10h.96V7.407H20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C6691",
    d: "M14 19.095h-1.613V17h-.774v2.095H10v.805h1.613V22h.774v-2.1H14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB9028",
    d: "M10 6.615H7.447V4h-.894v2.615H4v.77h2.553V10h.894V7.385H10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C6691",
    d: "M22 11.676h-1.616V10h-.768v1.676H18v.648h1.616V14h.768v-1.676H22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E457E",
    fillRule: "evenodd",
    d: "M20 16.602h-2.52V14h-.96v2.602H14v.796h2.52V20h.96v-2.602H20z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7098A4",
    d: "M11.693 2v1.735H10v.525h1.693V6h.614V4.26H14v-.525h-1.693V2zM6 11.724H4.3V10h-.6v1.724H2v.552l1.7-.008V14h.6v-1.737l1.7-.009z"
  }));
};
export var Tableau = function Tableau(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: TableauSvg
  }));
};